import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [food, setfood] = useState(false);
   
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
                if (item.id === 538) {
                    setdrinks(item);
                }
                if (item.id === 522) {
                    setfood(item);
                }
            });
      }, [menus]);
    

    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            getInitData()

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    

    return (
        <LayoutContent isHome={false}  showPinCode={true} showBack={false} showImageTop={true} showHome={false} showFooter={true } setShowSpecials={() => {
            setShowSpecials(true)
        }} goCategories={setshowCategories}> 
            <div>
                <div style={{ width: '100%' }}>
                    <img
                        style={{
                            width: 390,
                            height: 170,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: -20,
                            marginBottom: -20,
                            position: 'relative'
                            
                        }}
                        src={require('./assets/logo.jpg')}
                    />
                </div>
                <div style={{ display: 'flex', width: '100%',  position: 'relative', zIndex: 100,  paddingInline: 20, boxSizing: 'border-box', marginTop: 30 }}>
                        
                    <div style={{ width: '60%'}}>

                        <div>
                            <img
                            
                            onClick={()=>setshowCategories(true)}
                                style={{
                                    width: '100%',
                                    height: 205,
                                    objectFit: 'contain',
                                    borderRadius: 14,
                                   
                                }}
                                src={require('./assets/rghjfg.png')}
                            />
                            
                        </div>
                        
                        <img
                            onClick={() => {
                                setdishs(drinks)
                                setShowListProduct(true)
                            }}
                            style={{
                                      marginTop: 7,
                                    width: '100%',
                                    height: 215,
                                    objectFit: 'contain',
                                    borderRadius: 14,
                                }}
                                src={require('./assets/banner2.png')}
                            />
                    </div>
                    <div style={{ width: '40%'}}>
                        <video
                            src={require('./assets/bannerv.mp4')}
                            loop autoPlay={true} muted 
                            style={{
                                width: '100%',
                                height: 430,
                                objectFit: 'conatin',
                                borderRadius: 14,
                            }}
                        />

                    </div>
                    
                </div>
               
            </div>
            <div
                style={{
                    width: '100%',
                    alignItems: 'center',
                    paddingInline: 40,
                    boxSizing: 'border-box',
                    marginTop: 10,
                    position: 'relative',
                    zIndex: 999,
                   
                }}>
                <video
                    src={require('./assets/bannerh.mp4')}
                     loop autoPlay={true} muted 
                    style={{
                        width: 665,
                        height: 180,
                        objectFit: 'cover',
                        borderRadius: 15,
                      
                    }}
                />
            </div>

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
            {showBar && <BarScreen setShowBar={setShowBar} />}
            
{/* 
            <img
                style={{
                    width: 200,
                    height: 340,
                    objectFit: 'contain',
                    borderRadius: 14,
                    position: 'absolute',
                    top: 50,
                    left: -10,
                }}
                src={require('./assets/item6.png')}
      /> */}

      <img
        style={{
          width: 300,
          height: 400,
          objectFit: 'contain',
          borderRadius: 14,
          position: 'absolute',
          top: -20,
                    right: 0,
          zIndex: 10
        }}
        src={require('./assets/item2.png')}
      />
      <img
        style={{
          width: 800,
          height: 500,
          objectFit: 'contain',
          borderRadius: 14,
          position: 'absolute',
          bottom: -70,
          left: -30,
                    zIndex: 1,
                    zIndex: 100,
           opacity: 0.2
        }}
        src={require('./assets/item3.png')}
      />
            

             {/* <img
        style={{
          width: 300,
          height: 200,
          objectFit: 'contain',
          borderRadius: 14,
          position: 'absolute',
          bottom: 10,
          right: -40,
                    zIndex: 1,
                    zIndex: 100,
          
        }}
        src={require('./assets/item4.png')}
      />
             */}
        </LayoutContent>
    );
}

export default Index;